module.exports = __webpack_public_path__ + "static/media/blank_instructions.8380a3fa.jpg";